import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LabelLift from "../UI/LabelLift";

const Lift22 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift22" className={getLiftClass(isOpen, activeLiftId === '22', state)}
			 transform="translate(2061.000000, 1191.000000)">
			<line
				x1="233.5" y1="12.5" x2="13.25" y2="230.25" id="Line" stroke={colors[0]}
				strokeWidth="3" strokeLinecap="round" strokeDasharray="6"
				className="animated"
			/>

			<LiftLabelTypeSeat
				seatCount="4" coords="109.000000, 96.000000"
				colors={getLiftStatusColors(state, isOpen)}
				isOpen={isOpen}
				animationPart={2}/>

			<g id="Labe-lift" transform="translate(0.000000, 215.000000)">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(13.513140, 227.513140) scale(-1, 1) rotate(-317.000000) translate(-13.513140, -227.513140) "
				points="8.01313972 227.51314 19.0131397 222.01314 16.6416525 227.51314 19.0131397 233.01314"/>

			<LabelLift coords="220.000000, 0.000000" isOpen={isOpen} text={<tspan x="-2.3" y="13">22</tspan>} state={state}/>
		</g>
	);
};


Lift22.propTypes = {};

export default Lift22;
